import React from 'react';
import LocalizedStrings from 'react-localization';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import queryString from 'query-string';

function InsuranceTitle(props) {
  const strings = new LocalizedStrings({
    ru: {
      main: 'Главная',
      calc: 'Расчет стоимости КАСКО',
      insurance: 'Cтрахование',
      title: 'КАСКО',
      subtitle: 'Официальные цены от страховых компаний',
      get1: 'Определите рыночную',
      get2: 'стоимость авто',
      enter1: 'Введите данные',
      enter2: 'об авто и водителе',
      compare1: 'Сравните предложения',
      compare2: 'от страховых компаний',
      apply1: 'Оформите заявки',
      apply2: 'и получите полис',
    },
    ua: {
      main: 'Головна',
      calc: 'Розрахунок вартості КАСКО',
      insurance: 'Страхування',
      title: 'КАСКО',
      subtitle: 'Офіційні ціни від страхових компаній',
      get1: 'Визначте ринкову',
      get2: 'вартість авто',
      enter1: 'Введіть дані',
      enter2: 'про авто і водія',
      compare1: 'Порівняйте пропозиції',
      compare2: 'від страхових компаній',
      apply1: 'Oформіть заявки',
      apply2: 'і отримаєте поліс',
    },
  });
  strings.setLanguage(props.locale);
  const values = queryString.parse(props.location.search);
  const url = `?step=2&car=${values.car}&model=${values.model}&year=${values.year}&fuel=${values.fuel}&transmission=${values.transmission}&engine=${values.engine}&distance=${values.distance}&drivers=${values.drivers}&age=${values.age}&experience=${values.experience}&taxi=${values.taxi}&credit=${values.credit}`;
  return (
    <div>
      <section id="banner">
        <div className="bg-svg" />
        <div className="container">
          <div className="txt">
            <h1>{strings.title}</h1>
            <p className="subtitle">{strings.subtitle}</p>
            <div className="step-block">
              <div className="item">
                <div className="number">01</div>
                <div className="value"><p>{strings.get1}<br /> {strings.get2}</p></div>
              </div>
              <div className="arrow"><svg width={10} height={18} viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.8" d="M1 1L9 9L1 17" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></svg></div>
              <div className="item">
                <div className="number">02</div>
                <div className="value"><p>{strings.enter1} <br />{strings.enter2}</p></div>
              </div>
              <div className="arrow"><svg width={10} height={18} viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.8" d="M1 1L9 9L1 17" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></svg></div>
              <div className="item">
                <div className="number">03</div>
                <div className="value"><p>{strings.compare1}<br /> {strings.compare2}</p></div>
              </div>
              <div className="arrow"><svg width={10} height={18} viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.8" d="M1 1L9 9L1 17" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></svg></div>
              <div className="item">
                <div className="number">04</div>
                <div className="value"><p>{strings.apply1} <br />{strings.apply2}</p></div>
              </div>
            </div>
          </div>
        </div>{/* container */}
      </section>
    </div>

  );
}

export default withRouter(InsuranceTitle);
